/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarketFormValidationData
 */
export interface MarketFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof MarketFormValidationData
     */
    id?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof MarketFormValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof MarketFormValidationData
     */
    label?: ValidationMessage;
}

export function MarketFormValidationDataFromJSON(json: any): MarketFormValidationData {
    return MarketFormValidationDataFromJSONTyped(json, false);
}

export function MarketFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : ValidationMessageFromJSON(json['id']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
    };
}

export function MarketFormValidationDataToJSON(value?: MarketFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': ValidationMessageToJSON(value.id),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'label': ValidationMessageToJSON(value.label),
    };
}


